import { render, staticRenderFns } from "./CloudsRating.vue?vue&type=template&id=37365c76&scoped=true&"
import script from "./CloudsRating.vue?vue&type=script&lang=js&"
export * from "./CloudsRating.vue?vue&type=script&lang=js&"
import style0 from "./CloudsRating.vue?vue&type=style&index=0&id=37365c76&lang=scss&scoped=true&"
import style1 from "./CloudsRating.vue?vue&type=style&index=1&id=37365c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37365c76",
  null
  
)

export default component.exports